import React, { useState } from 'react';
import { PenSquare, ListChecks, BarChart3 } from 'lucide-react';
import AdminNotificationCompose from './AdminNotificationCompose';
import AdminNotificationList from './AdminNotificationList';
import AdminNotificationStats from './AdminNotificationStats';

type Tab = 'compose' | 'list' | 'stats';

const TABS: { key: Tab; label: string; icon: React.ComponentType<{ size?: number }> }[] = [
  { key: 'compose', label: 'สร้าง / แก้ไขประกาศ', icon: PenSquare },
  { key: 'list', label: 'รายการประกาศ', icon: ListChecks },
  { key: 'stats', label: 'สถิติ & ผลส่ง', icon: BarChart3 },
];

const AdminNotificationsPage: React.FC = () => {
  const [tab, setTab] = useState<Tab>('compose');
  const [selectedId, setSelectedId] = useState('');

  const selectAndCompose = (id: string) => {
    setSelectedId(id);
    setTab('compose');
  };

  // แท็บ compose บนจอกว้าง: ล็อกความสูงพอดีจอ (หักแถบเมนูบน ~3.6rem) ให้แต่ละคอลัมน์เลื่อนแยกกันเอง
  const fitScreen = tab === 'compose';

  return (
    <div
      className={`max-w-[1800px] mx-auto px-4 md:px-6 py-4 ${fitScreen ? 'xl:h-[calc(100vh-3.6rem)] xl:flex xl:flex-col' : ''}`}
      style={{ color: 'var(--text-color)' }}
    >
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4 xl:shrink-0">
        <div>
          <span className="text-[11px] font-bold tracking-widest" style={{ color: 'var(--green-text-color)' }}>ADMIN CENTRE</span>
          <h1 className="text-xl font-black leading-tight">จัดการแจ้งเตือน</h1>
        </div>

        <div className="flex flex-wrap gap-2">
          {TABS.map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-sm font-semibold transition-colors"
              style={tab === key
                ? { backgroundColor: 'var(--button-create-bg)', color: 'var(--button-text-color)' }
                : { backgroundColor: 'var(--component-bg-color)', color: 'var(--text-color)' }}
            >
              <Icon size={15} /> {label}
            </button>
          ))}
        </div>
      </div>

      {tab === 'compose' && (
        <div className="xl:flex-1 xl:min-h-0">
          <AdminNotificationCompose selectedId={selectedId} onSelectId={setSelectedId} onGoToList={() => setTab('list')} />
        </div>
      )}
      {tab === 'list' && <AdminNotificationList onSelect={selectAndCompose} />}
      {tab === 'stats' && <AdminNotificationStats initialId={selectedId} />}
    </div>
  );
};

export default AdminNotificationsPage;
